// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"497b7ad3","441":"75748769","453":"4293b0e1","670":"3867f8fb","720":"db70e6a1","797":"3c23d064","873":"494e8eb0"}[chunkId] + ".chunk.js";
};